module.exports = __webpack_public_path__ + "img/kyowa.8eea1280.png";